function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowwithcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2385",
    d: "M0 5a5 5 0 1 1 5 5 5 5 0 0 1-5-5zm6.083 2.33a.6.6 0 0 0 0-.843L4.582 5l1.5-1.483a.6.6 0 0 0 0-.843.608.608 0 0 0-.852 0L3.307 4.582a.6.6 0 0 0 0 .843l1.924 1.9a.607.607 0 0 0 .852.005z",
    transform: "rotate(180 5 5)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowwithcircle);
export default __webpack_public_path__ + "static/media/Arrowwithcircle.ae585db43827b0c2ff9d71614b4347cc.svg";
export { ForwardRef as ReactComponent };